export default "__VITE_ASSET__EpGPUoaH__"